import { render } from "./avatarUpload.vue?vue&type=template&id=271a3546&scoped=true"
import script from "./avatarUpload.vue?vue&type=script&lang=js"
export * from "./avatarUpload.vue?vue&type=script&lang=js"

import "./avatarUpload.vue?vue&type=style&index=0&id=271a3546&lang=scss"
import "./avatarUpload.vue?vue&type=style&index=1&id=271a3546&lang=scss&scoped=true"

import exportComponent from "F:\\webStorm workspace\\ujk_tangying\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-271a3546"]])

export default __exports__